import { Gauge, BadgeDollarSign, CreditCard, ShieldCheck, Wrench, Layers } from "lucide-react";

export const CONTACT = {
  phoneDisplay: "321-701-4356",
  phoneRaw: "+13217014356",
  email: "orlandodemandrides@gmail.com",
  brand: "ORL",
  brandSub: "On Demand Rides",
  location: "Orlando, Florida",
};

export const IMAGES = {
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/3i0fg4i5_1782692094926.jpg",
  heroPerson: "https://images.unsplash.com/photo-1596879761128-b732079dac20?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  driver: "https://images.unsplash.com/photo-1658134424788-d67ebbd8ef5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  keys: "https://images.unsplash.com/photo-1557598628-bdd7d0767917?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  road: "https://images.unsplash.com/photo-1559493909-ee5feb0b298d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  driverCouple: "https://images.unsplash.com/photo-1711934358931-8164fd58b365?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  heroBg: "https://images.unsplash.com/photo-1758464643041-a22da8403070?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  skyline: "https://images.unsplash.com/photo-1758464642918-47f7d0364396?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sedan: "https://images.unsplash.com/photo-1773793100837-45c7f4cee486?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
};

export const DEFAULT_VIDEOS = [
  {
    id: "default-1",
    title: "How the Rental Process Works",
    description: "See how quick and easy it is to get your car with ORL On Demand Rides.",
    src: "https://customer-assets.emergentagent.com/job_rent-wheels-123/artifacts/tzqn6da4_VID_20260701_181029_225.mp4",
  },
  {
    id: "default-2",
    title: "Getting Your Car & Hitting the Road",
    description: "A walkthrough of picking up your rental and getting on the road.",
    src: "https://customer-assets.emergentagent.com/job_rent-wheels-123/artifacts/737iyhmo_VID_20260701_181036_969.mp4",
  },
  {
    id: "default-3",
    title: "A Closer Look at Our Rentals",
    description: "See the ORL On Demand Rides experience up close.",
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/sqhu7jew_PXL_20260711_223404728.mp4",
  },
];

export const PLATFORMS = [
  { name: "Uber", color: "#000000" },
  { name: "Lyft", color: "#EA0B8C" },
  { name: "Instacart", color: "#0AAD0A" },
  { name: "DoorDash", color: "#FF3008" },
  { name: "Grubhub", color: "#F63440" },
];

export const FEATURES = [
  { icon: Gauge, title: "200 Miles Per Day", desc: "Generous daily mileage included. Rentals stay in the Central FL area — Orange, Osceola, Lake, Seminole & Sumter counties." },
  { icon: BadgeDollarSign, title: "Cars from $55 / Day", desc: "Affordable rates with no hidden fees." },
  { icon: CreditCard, title: "No Credit Cards Needed", desc: "A simple, easy approval process." },
  { icon: ShieldCheck, title: "No Credit Checks", desc: "We make it simple to get started today." },
  { icon: Layers, title: "Drive For Any Platform", desc: "Uber, Lyft, Instacart, DoorDash, Grubhub & more." },
  { icon: Wrench, title: "Coverage & Maintenance", desc: "Coverage and maintenance are included with every rental." },
];

export const PAYMENTS = ["Cash App", "Venmo", "Apple Pay"];

export const PLATFORM_OPTIONS = ["Uber", "Lyft", "Instacart", "DoorDash", "Grubhub", "Travel Nurse", "Other"];

export const CARS = [
  {
    id: "tesla",
    name: "Tesla Model Y Long Range",
    tagline: "All-electric premium SUV",
    price: 95,
    deposit: 100,
    minDays: 3,
    badge: "Premium",
    specs: [
      "All-electric — skip the gas station",
      "Premium leather interior",
      "Panoramic glass roof",
      "Big touchscreen & Autopilot",
    ],
    images: [
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/dnp7p9yb_PXL_20260821_180700739.webp",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/3aoly25b_PXL_20260821_180721642.webp",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/lgizsh4y_15615_clean.webp",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/xttuxeqm_9452_clean.webp",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/80zzgv60_9461_clean.webp",
    ],
  },
  {
    id: "hyundai",
    name: "Hyundai Sonata",
    tagline: "Spacious & fuel-efficient",
    price: 55,
    deposit: 100,
    minDays: 4,
    badge: "Best Value",
    specs: [
      "Excellent on gas",
      "Roomy leather-trimmed cabin",
      "Great for every platform",
      "Budget-friendly daily rate",
    ],
    images: [
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/n3ofui1p_Screenshot_20260920-161057~2.jpg",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/z8zqajag_Screenshot_20260920-161113~2.jpg",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/navdbl5g_Screenshot_20260920-161041~2.jpg",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/0rmvc4o4_Screenshot_20260920-161049~2.jpg",
      "https://customer-assets-4nw71qhi.emergentagent.net/job_rent-wheels-123/artifacts/2md19x9c_Screenshot_20260920-161053~2.jpg",
    ],
  },
];
